import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MasterOrderPaymentPages } from '@core/enums/master-order-payment-pages.enum';
import { RiskData } from '@core/models/risk-data.model';
import { AppInitService } from '@core/services/app-init.service';
import { AppState } from '@core/store';
import { fetchMasterOrderData, resetMasterOrderFetched } from '@core/store/order/order.actions';
import { Store } from '@ngrx/store';
import { NavigationStep } from '@shared/components/stepper-base/navigation-step.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-master-order-payment',
  templateUrl: './master-order-payment.component.html',
  styleUrls: ['./master-order-payment.component.scss'],
})
export class MasterOrderPaymentComponent implements OnInit, OnDestroy {
  pages = MasterOrderPaymentPages;
  activePage: MasterOrderPaymentPages;
  navigationSteps: NavigationStep[];
  isCollectRiskDataEnabled: boolean = false;
  title: string;
  nextTitle: string;
  orderNumber: string;

  public riskData?: RiskData;

  private subscriptions: Subscription = new Subscription();

  constructor(
    appInitService: AppInitService,
    private store$: Store<AppState>,
    private activatedRoute: ActivatedRoute,
  ) {
    this.isCollectRiskDataEnabled = appInitService.Settings.ec.masterOrderCollectRiskDataFromInput;
  }

  ngOnInit(): void {
    this.navigationSteps = this.initNavigationSteps();
    this.activePage = this.navigationSteps[0].id;
    this.changeStepTitles(MasterOrderPaymentPages.SearchPage);

    this.subscriptions.add(
      this.activatedRoute.paramMap.subscribe((pMap) => {
        this.orderNumber = pMap.get('orderNumber');
        if (this.orderNumber) {
          this.store$.dispatch(fetchMasterOrderData({ orderNumber: this.orderNumber }));
        }
      }),
    );
  }

  reset(): void {
    this.riskData = undefined;
    this.store$.dispatch(resetMasterOrderFetched());
  }

  changePage(page: MasterOrderPaymentPages): void {
    if (page === this.pages.SearchPage) {
      this.reset();
    }
    this.changeStepTitles(page);
    this.activePage = page;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private initNavigationSteps(): NavigationStep[] {
    return [
      { id: MasterOrderPaymentPages.SearchPage, title: $localize`Order number` },
      { id: MasterOrderPaymentPages.AddressPage, title: $localize`Billing Address` },
      { id: MasterOrderPaymentPages.InfoPage, title: $localize`Payment` },
    ].sort((a, b) => a.id - b.id);
  }

  private changeStepTitles(stepId: number): void {
    this.title = this.navigationSteps.find((navStep) => navStep.id === stepId)?.title;
    this.nextTitle = this.navigationSteps.find((navStep) => navStep.id === stepId + 1)?.title;
  }
}
